import React, { useEffect } from 'react';

import { useThreeDs } from '../../../../hooks';

type ThreeDsSecureModal = {
  /**
   * Modal display mode
   */
  displayMode: 'layer' | 'window';
  /**
   * Close event handler
   */
  onClose: () => void;
  /**
   * Catalog id
   */
  catalogId: number;
  /**
   * Subscription id
   */
  subscriptionId: number;
  /**
   * ThreeDsActionLink
   */
  threeDsActionLink: string;
  /**
   * Close event handler
   */
  onSuccess: () => void;
};

const Content = ({
  onClose,
  catalogId,
  subscriptionId,
  threeDsActionLink,
  onSuccess,
}: ThreeDsSecureModal) => {
  const threeDsService = useThreeDs({
    catalogId,
    subscriptionId,
    onSuccess,
  });

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.data?.THREE_DS_STATUS) {
        threeDsService.send('THREE_DS_SUCCESS');
      }
      if (event.data?.THREE_DS_STATUS === false) {
        onClose();
      }
    });
    return () => window.removeEventListener('message', () => {});
  }, [threeDsActionLink]);

  return (
    <iframe
      title={'3ds-confirmation'}
      src={threeDsActionLink}
      style={{
        width: '700px',
        height: '700px',
        border: 'none',
      }}
    />
  );
};

export default Content;
